module.exports = __webpack_public_path__ + "img/10.ba5fb6ec.png";